<template>
  <div class="flex flex-wrap">
    <div class="flex">
      <div class="mr-3">Sort by:</div>
      <select class="sort-order-select" v-model="orderby">
        <option value="price">Price</option>
        <option value="date">Date</option>
        <option value="popularity">Popularity</option>
        <option value="rating">Rating</option>
        <option value="title">Title</option>
      </select>
    </div>
    <div class="flex">
      <div class="mr-3">Sort order:</div>
      <select class="sort-order-select" v-model="order">
        <option value="desc">Descending</option>
        <option value="asc">Ascending</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "SortOrder",
  props: {
    sortBy: {
      type: String,
      default: "price",
    },
    sortOrder: {
      type: String,
      default: "desc",
    },
  },
  data() {
    return {
      order: this.sortOrder,
      orderby: this.sortBy,
    };
  },
  watch: {
    order() {
      this.$emit("order-change", {
        order: this.order,
        orderby: this.orderby,
      });
    },
    orderby() {
      this.$emit("order-change", {
        order: this.order,
        orderby: this.orderby,
      });
    },
    sortBy(newVal) {
      this.orderby = newVal;
    },
    sortOrder(newVal) {
      this.order = newVal;
    },
  },
};
</script>

<style scoped>
.flex {
  align-items: center;
  gap: 10px;
}
</style>

<style>
.sort-order-select {
  padding: 8px;
  border-radius: 7px;
  border-color: #ccc;
  background-color: white;
  color: #555;
}

.sort-order-select:focus {
  outline: var(--theme);
}
</style>
